<script lang="ts" setup>
/**
 * トークルーム情報 > 投稿日。
 */

import { defineProps } from "vue";
import DateUtil from "@/modules/utils/dateUtil";

interface Props {
	/**
	 * 投稿日。
	 */
	talkRoomDate: string;
}
const props = defineProps<Props>();

/**
 * 投稿日を`YYYY.MM.DD`のString型に変換。
 * ユーザーの入力値で動的に変更される値ではない為、reactiveにする必要はなし。
 */
const convertDate = DateUtil.convertDiplayFormat(props.talkRoomDate);
</script>

<template>
	<p class="revico-community-talk-talkroom-details--date">{{ convertDate }}</p>
</template>

<style lang="scss">
.revico-widget .revico-community-talk {
	&-talkroom-details {
		&--date {
			width: 100%;
			font-size: 0.8em;
			text-align: right;
		}
	}
}
</style>
